import { Text, Tooltip } from "@mantine/core";
import { useOnlineUsers } from "../../../../../api/useOnlineUsers";
import CircleContainer from "../CircleContainer";
import { Link } from "@tanstack/react-router";
import useOnlineUsersTooltip from "./hooks";
import classes from "./styles.module.css";
import useIsMobile from "../../../../../hooks/useIsMobile";
import useSkillsterStore from "../../../../../store/app";

function OnlineCounter() {
  const onlineUsersQuery = useOnlineUsers();
  const count = onlineUsersQuery.data?.list.length ?? 0;
  const onlineUsersTooltip = useOnlineUsersTooltip();
  const mobile = useIsMobile();
  const setMobileOpened = useSkillsterStore((state) => state.setMobileMenuOpen);

  return (
    <Link
      to="/users"
      search={{
        sort: count > 0 ? "online" : undefined,
      }}
      mask={{
        to: "/users",
      }}
      onClick={() => setMobileOpened(false)}
    >
      <Tooltip label={onlineUsersTooltip} openDelay={500} disabled={mobile}>
        <CircleContainer>
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M3 9.51367C4.10313 9.51367 5 8.57943 5 7.43034C5 6.28125 4.10313 5.34701 3 5.34701C1.89688 5.34701 1 6.28125 1 7.43034C1 8.57943 1.89688 9.51367 3 9.51367ZM17 9.51367C18.1031 9.51367 19 8.57943 19 7.43034C19 6.28125 18.1031 5.34701 17 5.34701C15.8969 5.34701 15 6.28125 15 7.43034C15 8.57943 15.8969 9.51367 17 9.51367ZM18 10.5553H16C15.45 10.5553 14.9531 10.7865 14.5906 11.1608C15.85 11.8802 16.7437 13.179 16.9375 14.722H19C19.5531 14.722 20 14.2565 20 13.6803V12.6387C20 11.4896 19.1031 10.5553 18 10.5553ZM10 10.5553C11.9344 10.5553 13.5 8.92448 13.5 6.90951C13.5 4.89453 11.9344 3.26367 10 3.26367C8.06563 3.26367 6.5 4.89453 6.5 6.90951C6.5 8.92448 8.06563 10.5553 10 10.5553ZM12.4 11.597H12.1406C11.4906 11.9225 10.7688 12.1178 10 12.1178C9.23125 12.1178 8.5125 11.9225 7.85938 11.597H7.6C5.6125 11.597 4 13.2767 4 15.347V16.2845C4 17.1471 4.67188 17.847 5.5 17.847H14.5C15.3281 17.847 16 17.1471 16 16.2845V15.347C16 13.2767 14.3875 11.597 12.4 11.597ZM5.40938 11.1608C5.04688 10.7865 4.55 10.5553 4 10.5553H2C0.896875 10.5553 0 11.4896 0 12.6387V13.6803C0 14.2565 0.446875 14.722 1 14.722H3.05938C3.25625 13.179 4.15 11.8802 5.40938 11.1608Z"
                fill="white"
              />
            </svg>

            <div
              className={`${classes.sonar} ${count > 0 ? classes.animate : ""}`}
            >
              <Text
                fw={700}
                fz={10}
                c={count > 0 ? "bluegray.6" : "bluegray.9"}
              >
                {count}
              </Text>
            </div>
          </>
        </CircleContainer>
      </Tooltip>
    </Link>
  );
}

export default OnlineCounter;
